import React from 'react';
import heroVideo from '../assets/c87603a4.mp4'; // Import your video file
import heroImG from '../assets/citylogo.png'; // Import your video file


const Hero = () => {
  return (
    <div className="w-screen h-screen md:h-[700px] overflow-hidden relative">
      <div className="absolute inset-0">
        <video 
          className="object-cover w-full h-full" 
          src={heroVideo} 
          autoPlay 
          loop 
          muted 
          playsInline 
          preload="auto" 
          poster={heroImG}  
        />
      </div>

      <div className="absolute inset-0 flex flex-col justify-center items-center text-white p-6 md:px-[120px] bg-black bg-opacity-80">
        <div className="sm:h-[250px] w-full mx-[24px] md:mx-[90px] lg:mx-[120px] flex flex-col justify-between">
          <h2 className="text-center text-2xl md:text-4xl font-bold mb-4">
            Christ Apostolic Church, City Of God.
          </h2>
          <p className="text-center text-[18px] md:text-xl mb-12 md:mb-6 mt-2">
            Experience God’s Presence at the City of God, where we seek God through Jesus Christ and his divine presence above all else. Join us in a journey of faith, seeking not gold, but the grace and peace found in Jesus our Lord and Saviour.
          </p>
          <div className="flex justify-center items-center mt-2">
            <div className="flex flex-col md:flex-row md:space-x-[50px] justify-center items-center space-y-[24px] md:space-y-0 w-full">
              <a href='/live'>
                <button className="rounded-lg bg-orange-500 hover:bg-orange-700 text-white h-[48px] w-[170px] md:h-[56px] md:w-[200px]">
                  Watch Live
                </button>
              </a>
              <a href='/sermon'>
                <button className="rounded-lg border border-orange-500 hover:bg-orange-700 hover:text-white text-orange-500 h-[48px] w-[170px] md:h-[56px] md:w-[200px]">
                  Read Sermon
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
